<template>
    <div style="display: flex;">
        <el-select v-if="suggestAccountItems.length" :disabled="disabled" style="width: 200px" :value="value" @input="onInput">
            <el-option v-for="option in suggestAccountItems" :key="option.accno" :label="`${option.accno} - ${option.accnam}`" :value="option.accno"> </el-option>
        </el-select>
        <div v-else>
            <el-input style="width: 200px" value="（無對照會計科目）" disabled> </el-input>
        </div>
    </div>
</template>

<script>
import _ from 'lodash';

export default {
    props: {
        value: {
            type: [Number, String],
            default: null,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        statementOptions() {
            return this.$store.getters['statement/statementOptions'];
        },
    },
    data() {
        return {
            suggestAccountItems: [],
        };
    },
    methods: {
        init(sno) {
            const ACCOUNTING_ITEM = this.getItem(sno);
            this.setSuggestAccountItems(ACCOUNTING_ITEM, true);
        },
        setSuggestAccountItems(val, init) {
            this.suggestAccountItems = [];
            console.log('val', val);
            this.$nextTick(() => {
                let inputVal = this.value ? `${this.value}` : this.value;
                if (init) {
                    console.log([val.accno, ...val.suggestedAccItems.map((o) => o.accno)], inputVal);
                    if (![val.accno, ...val.suggestedAccItems.map((o) => o.accno)].includes(inputVal)) inputVal = val.accno && `${val.accno}`;
                    this.$emit('input', inputVal);
                } else this.$emit('input', val.accno && `${val.accno}`);
                this.$emit('loaded', !!val.suggestedAccItems?.length);

                this.suggestAccountItems = val.suggestedAccItems;
                const FOUND = _.find(this.suggestAccountItems, ['accno', val.accno]);
                if (val.accno && !FOUND) {
                    this.suggestAccountItems.push({
                        acItemSno: val.sno,
                        accnam: val.accnam,
                        accno: val.accno,
                    });
                }
                this.$emit('loaded', !!this.suggestAccountItems.length);
            });
        },
        onInput(val) {
            this.$emit('input', val);
        },
        getItem(sno) {
            if (!sno) return {};
            const states = this.statementOptions;

            // eslint-disable-next-line no-restricted-syntax, guard-for-in
            for (const type in states) {
                for (let i = 0; i < states[type].length; i += 1) {
                    for (let j = 0; j < states[type][i].childSettings.length; j += 1) {
                        if (states[type][i].childSettings[j].sno === sno) {
                            return states[type][i].childSettings[j];
                        }
                    }
                }
            }
            return {};
        },
    },
};
</script>
